var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-linear-progress',{attrs:{"value":_vm.value / 100,"color":_vm.color,"reverse":_vm.reverse,"rounded":_vm.rounded,"size":_vm.size,"track-color":_vm.trackColor}})}
var staticRenderFns = []

export { render, staticRenderFns }